import "./SignIn.css";
import { ReactComponent as FrameBack } from "images/frame_back.svg";
import { ReactComponent as MainLogo } from "images/main-logo.svg";
import { ReactComponent as Email } from "images/email-forgot.svg";
import { TextField } from "@material-ui/core";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ChangeEvent, FocusEvent, useEffect, useState } from "react";
import { getErrorComponents } from "../../services/util";
import useSignInForm from "./utils";
import TalaeraSpinner from "../../components/TalaeraSpinner/TalaeraSpinner";
import TalaeraRoutes from "../../components/routes/TalaeraRoutes";
import { forgotPassword } from "../../services/authUtil";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    account,
    setAccount,
    errors: formErrors,
    touched,
    setTouched,
    onValidate,
    onTouched,
  } = useSignInForm({ email: "" });
  const { t, i18n } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [resetDone, setResetDone] = useState(false);

  const handleChangeField = (e: ChangeEvent<HTMLInputElement>) => {
    if (resetDone) {
      setResetDone(false);
    }
    setAccount({ ...account, [e.target.name]: e.target.value });
  };

  const handleBlurField = (e: FocusEvent<HTMLInputElement>) => {
    onTouched(e.target.name);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const isValidated = onValidate();
    setTouched({
      email: true,
    });

    if (isValidated) {
      setErrors("");
      setLoading(true);
      forgotPassword(
        { email: account.email },
        () => {
          // _this.props.showToast && _this.props.showToast(TOAST_MESSAGE);
          setLoading(false);
          setResetDone(true);
        },
        (error: any) => {
          setErrors(error);
          setLoading(false);
        }
      );
    }
  };

  useEffect(() => {
    if (location && location?.state?.error) {
      setErrors(location?.state?.error);
      navigate(location.pathname, { state: null, replace: true });
    }
    // eslint-disable-next-line
  }, [location]);

  return (
    <div className="sign-in-page forgot-password">
      <Helmet htmlAttributes={{ lang: i18n.language }}>
        <title>Talaera | Reset your password</title>
        <meta
          name="description"
          content="This page is for registered user to reset their password"
        />
      </Helmet>

      <div className="sign-in-content">
        <MainLogo />

        {errors && <div className="sign-in-error">{getErrorComponents(errors)}</div>}

        {!resetDone && (
          <>
            <div className="sign-in-header">
              <h1>Reset your password</h1>
            </div>

            <div className="sign-in-description">
              Enter your email address and we will send you instructions to reset your
              password.
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-wrapper">
                <TextField
                  name="email"
                  label={t("ForgotPassword.Email address")}
                  placeholder="johnsmith@gmail.com"
                  variant="outlined"
                  value={account.email}
                  error={!!(formErrors.email && touched.email)}
                  helperText={touched.email && formErrors.email}
                  onChange={handleChangeField}
                  onBlur={handleBlurField}
                />

                {loading ? (
                  <div className="sign-in-spinner">
                    <TalaeraSpinner />
                  </div>
                ) : (
                  <button className="btn" type="submit">
                    Continue
                  </button>
                )}
              </div>
            </form>
          </>
        )}

        {resetDone && (
          <div className="reset-sent-container">
            <Email />

            <h1>Check your email</h1>

            <p>
              Please check the email address {account.email} for instructions to reset
              your password.
            </p>

            <button className={"resend-btn"}>Resend email</button>
          </div>
        )}
      </div>

      <div>
        {/* eslint-disable-next-line */}
        <Link to={TalaeraRoutes.SIGN_IN.path}>← {t("ForgotPassword.Back to Login")}</Link>
      </div>

      <FrameBack className="sign-in-frame-back" />
    </div>
  );
};

export default ForgotPassword;
